import type { DeepPartial } from '@gitbook/util-ts';

import type { NavigationScreenState } from './types';

/**
 * Normalize a screen to avoid invalid state.
 * It throws an error if properties are missing.
 *
 * example: when current screen is { type: 'collection', collection: 'something' }
 * and a navigation call is done with { type: 'space', space: 'something' }
 * which miss a "page", etc
 */
export function normalizeNavigationScreen(
    screen: DeepPartial<NavigationScreenState>
): NavigationScreenState {
    switch (screen.type) {
        case 'space': {
            const { space } = screen;
            if (!space) {
                throw new Error('Navigation screen space is required');
            }

            // @ts-ignore - we know that the screen is valid
            return {
                type: 'space',
                page: '',
                space,
                ...screen,
            };
        }
        case 'collection': {
            const { collection } = screen;
            if (!collection) {
                throw new Error('Navigation screen collection is required');
            }

            // @ts-ignore - we know that the screen is valid
            return {
                type: 'collection',
                collection,
                ...screen,
            };
        }
        default:
            // @ts-ignore no normalization implemented yet, let's consider the screen is valid
            return screen;
    }
}
